export const GET_METRIC_AND_PRICE = 'METRICS/GET_METRIC_AND_PRICE';

export const getMetricAndPrice = (metricCode) => ({
  type: GET_METRIC_AND_PRICE,
  payload: {
    metricCode,
  },
});

export const GET_METRIC = 'METRICS/GET_METRIC';
export const GET_METRIC_PENDING = `${GET_METRIC}_PENDING`;
export const GET_METRIC_FULFILLED = `${GET_METRIC}_FULFILLED`;
export const GET_METRIC_REJECTED = `${GET_METRIC}_REJECTED`;

export const GET_DEPENDENCY = 'METRICS/GET_DEPENDENCY';
export const GET_DEPENDENCY_PENDING = `${GET_DEPENDENCY}_PENDING`;
export const GET_DEPENDENCY_FULFILLED = `${GET_DEPENDENCY}_FULFILLED`;
export const GET_DEPENDENCY_REJECTED = `${GET_DEPENDENCY}_REJECTED`;

export const GET_PRICES = 'METRICS/GET_PRICES';
export const GET_PRICES_PENDING = `${GET_PRICES}_PENDING`;
export const GET_PRICES_FULFILLED = `${GET_PRICES}_FULFILLED`;
export const GET_PRICES_REJECTED = `${GET_PRICES}_REJECTED`;

export const CHANGE_ASSET = 'METRICS/CHANGE_ASSET';

export const changeAsset = (asset) => ({
  type: CHANGE_ASSET,
  payload: {
    asset,
  },
});

export const CHANGE_METRIC = 'METRICS/CHANGE_METRIC';

export const changeMetric = (metricCode) => ({
  type: CHANGE_METRIC,
  payload: {
    metricCode,
  },
});

export const CHANGE_CURRENCY = 'METRICS/CHANGE_CURRENCY';

export const changeCurrency = (currency) => ({
  type: CHANGE_CURRENCY,
  payload: {
    currency,
  },
});

export const CHANGE_RESOLUTION = 'METRICS/CHANGE_RESOLUTION';

export const changeResolution = (resolution) => ({
  type: CHANGE_RESOLUTION,
  payload: {
    resolution,
  },
});

export const CHANGE_EXCHANGE = 'METRICS/CHANGE_EXCHANGE';

export const changeExchange = (exchange) => ({
  type: CHANGE_EXCHANGE,
  payload: {
    exchange,
  },
});

export const CHANGE_MINER = 'METRICS/CHANGE_MINER';

export const changeMiner = (miner) => ({
  type: CHANGE_MINER,
  payload: {
    miner,
  },
});

export const DOWNLOAD_METRIC_DATA = 'METRICS/DOWNLOAD_METRIC_DATA';
export const DOWNLOAD_METRIC_DATA_PENDING = `${DOWNLOAD_METRIC_DATA}_PENDING`;
export const DOWNLOAD_METRIC_DATA_FULFILLED = `${DOWNLOAD_METRIC_DATA}_FULFILLED`;
export const DOWNLOAD_METRIC_DATA_REJECTED = `${DOWNLOAD_METRIC_DATA}_REJECTED`;

export const DOWNLOAD_TIME_SERIES_DATA = 'METRICS/DOWNLOAD_TIME_SERIES_DATA';
export const downloadTimeSeriesData = (format) => ({
  type: DOWNLOAD_TIME_SERIES_DATA,
  payload: {
    format,
  },
});

export const downloadTimeSeriesCsv = () => downloadTimeSeriesData('csv');
export const downloadTimeSeriesJson = () => downloadTimeSeriesData('json');

export const DOWNLOAD_BAR_PLOT_DATA = 'METRICS/DOWNLOAD_BAR_PLOT_DATA';
export const downloadBarPlotData = (format) => ({
  type: DOWNLOAD_BAR_PLOT_DATA,
  payload: {
    format,
  },
});

export const downloadBarPlotCsv = () => downloadBarPlotData('csv');
export const downloadBarPlotJson = () => downloadBarPlotData('json');

export const DOWNLOAD_IMAGE = 'METRICS/DOWNLOAD_IMAGE';

export const downloadImage = () => ({
  type: DOWNLOAD_IMAGE,
});
